import { ClipboardPenLine, Inbox, UserCheck, CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    icon: ClipboardPenLine,
    title: "Post your job",
    text: "Tell us what you need, add photos, choose your location and set your budget.",
  },
  {
    n: "02",
    icon: Inbox,
    title: "Compare offers",
    text: "Receive offers from people who are available to help.",
  },
  {
    n: "03",
    icon: UserCheck,
    title: "Choose who you trust",
    text: "View profiles, ratings, reviews and verification information before choosing.",
  },
  {
    n: "04",
    icon: CheckCircle2,
    title: "Get it done",
    text: "Chat, arrange the job, pay securely and leave a review when it's complete.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>How it works</Eyebrow>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl">
            Getting help is simple.
          </h2>
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div
                data-testid={`how-it-works-step-${i + 1}`}
                className="group relative h-full bg-white rounded-2xl border border-slate-200/80 p-7 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-[box-shadow,transform] duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="w-12 h-12 rounded-xl bg-navy grid place-items-center group-hover:bg-teal transition-colors duration-300">
                    <s.icon className="w-5 h-5 text-white" />
                  </span>
                  <span className="font-mono text-sm font-semibold text-slate-300 group-hover:text-teal transition-colors duration-300">
                    {s.n}
                  </span>
                </div>
                <h3 className="mt-6 font-display font-bold text-navy text-xl">{s.title}</h3>
                <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
